<script>
import { baseMethods } from '@state/helpers/base.js'
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        assessmentLoader: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...baseMethods,
    },
}
</script>

<template>
    <div
        :class="{
            active: active,
            overlay: !assessmentLoader,
            'overlay-assessment': assessmentLoader,
        }"
    >
        <div class="loader-ring">
            <div class="loader-ring-light"></div>
            <div class="loader-ring-track"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/button-loader';
</style>
